import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import TopRightHeader from './headerRight.jsx';
import { setActiveTopHeader } from '../../containers/Header/actions/action';

const mapStateToProps = (state) => ({
    headerContext: state.headerContext,
    sessionContext: state.sessionContext
})
const mapDispatchToProps = (dispatch) => ({
    setActiveTopHeader: bindActionCreators(setActiveTopHeader, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(TopRightHeader);